import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INPATIENT_ACTION_TYPE } from "types/enums/inpatient";

type State = {
  actionType: INPATIENT_ACTION_TYPE;
  idSurgery: string | number;
  idDDNT: string | number;
  dataSurgery: any;
  optionICD: any[];
  idPhieu: number;
  listDoctor: any[];
  detailInfo: any;
  listDmPPPT: any[];
  thongTinBN: any;
  dataPhieu: any;
  idPhieuKham: any;
  listBCĐ: [];
  isChangeTab: boolean;
};

const initialState: State = {
  actionType: INPATIENT_ACTION_TYPE.NORMAL,
  idSurgery: null,
  idDDNT: null,
  dataSurgery: null,
  optionICD: null,
  idPhieu: null,
  listDoctor: null,
  detailInfo: null,
  listDmPPPT: null,
  thongTinBN: null,
  dataPhieu: null,
  idPhieuKham: null,
  listBCĐ: null,
  isChangeTab: false,
};

export const residentialNurseSlice = createSlice({
  name: "residentialNurse",
  initialState: initialState,
  reducers: {
    setDataSurgery: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        dataSurgery: actions.payload,
      };
    },
    setIdPhieuKham: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idPhieuKham: actions.payload,
      };
    },
    setIdDetailSurgery: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idSurgery: actions.payload,
      };
    },

    setIdDDNT: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idDDNT: actions.payload,
      };
    },
    setType: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        actionType: actions.payload,
      };
    },
    reloadData: (state = initialState) => {
      return {
        ...initialState,
      };
    },
    setOptionsIcd: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        optionICD: actions.payload,
      };
    },
    setListDoctor: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listDoctor: actions.payload,
      };
    },
    setIdReceiptSurgery: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        idPhieu: actions.payload,
      };
    },
    setDetailInfo: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        detailInfo: actions.payload,
      };
    },
    setData: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        ...actions,
      };
    },
    setListDmPPPT: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listDmPPPT: actions.payload,
      };
    },
    setThongTinBNDieuTri: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        thongTinBN: actions.payload,
      };
    },
    setDataPhieuDieuTri: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        dataPhieu: actions.payload,
      };
    },
    setListBCĐ: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listBCĐ: actions.payload,
      };
    },
    setIsChangetab: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        isChangeTab: actions.payload,
      };
    },
  },
});

export const {
  setDataSurgery,
  setIdDDNT,
  setType,
  setData,
  reloadData,
  setIdDetailSurgery,
  setIdPhieuKham,
  setOptionsIcd,
  setIdReceiptSurgery,
  setListDoctor,
  setThongTinBNDieuTri,
  setDetailInfo,
  setDataPhieuDieuTri,
  setListDmPPPT,
  setListBCĐ,
  setIsChangetab,
} = residentialNurseSlice.actions;
export default residentialNurseSlice.reducer;
